import { Log } from '@/types/logs'
import { IOfficialReport, OfficialReportRequestBody } from '@/types/officialReport'
import { IUserInfoResponse } from '@/types/user'

export const formatOfficialReportRequestBody = (
    requestBody: OfficialReportRequestBody,
    userInfo?: IUserInfoResponse,
    log?: Log
): IOfficialReport | null => {
    if (!log) {
        return null
    }

    return {
        ...requestBody,
        userShift: userInfo?.lastSessionDetails,
        driverBadgeNumber: requestBody.driverBadgeNumber,
        authorBadgeNumber: userInfo?.lastSessionDetails.badgeNumber,
        id: requestBody.id,
        logRecordId: log.id,
    } as unknown as IOfficialReport
}
